/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Font_Size_LabelInputs */

const en_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Size`)
};

const fr_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de police`)
};

const de_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftgröße`)
};

const it_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione del carattere`)
};

const ru_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер шрифта`)
};

const es_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de fuente`)
};

const zh_cn2_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体大小`)
};

const ja_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントサイズ`)
};

const hi_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट आकार`)
};

const pt_pt2_video_export_font_size_label = /** @type {(inputs: Video_Export_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da fonte`)
};

/**
* | output |
* | --- |
* | "Font Size" |
*
* @param {Video_Export_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_font_size_label = /** @type {((inputs?: Video_Export_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_font_size_label(inputs)
	if (locale === "de") return de_video_export_font_size_label(inputs)
	if (locale === "it") return it_video_export_font_size_label(inputs)
	if (locale === "ru") return ru_video_export_font_size_label(inputs)
	if (locale === "es") return es_video_export_font_size_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_font_size_label(inputs)
	if (locale === "ja") return ja_video_export_font_size_label(inputs)
	if (locale === "hi") return hi_video_export_font_size_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_font_size_label(inputs)
	return en_video_export_font_size_label(inputs)
});